import React, { useState, useEffect, useMemo } from "react";
import { FaMapMarkerAlt, FaCalendarAlt, FaUsers } from "react-icons/fa";
import {
  Row, Col, Form, Label, Input, Card, CardBody,
  Container, Button, FormFeedback, InputGroup
} from "reactstrap";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";

// Imports css
import '../../../assets/FrontEnd/css/font.css';
import '../../../assets/FrontEnd/plugins/bootstrap/css/bootstrap.min.css';
import '../../../assets/FrontEnd/css/font-awesome/font-awesome.min.css';
import '../../../assets/FrontEnd/css/magnific-popup.min.css';
import '../../../assets/FrontEnd/plugins/owlcarousel/owl.carousel.min.css';
import '../../../assets/FrontEnd/plugins/owlcarousel/owl.theme.default.min.css';
import '../../../assets/FrontEnd/css/style.css';
import '../../../assets/FrontEnd/js/toaster/toastr.min.css';
import '../../../assets/FrontEnd/css/fancybox/fancybox-v4-0-27.css';
import './FrontPageHome.css';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

const FrontPageHome = () => {
  const navigate = useNavigate();
  const [pickup, setPickup] = useState({ address: "", lat: null, lng: null });
  const [dropoff, setDropoff] = useState({ address: "", lat: null, lng: null });
  const [date, setDate] = useState(new Date());
  const [passenger, setPassenger] = useState(1);
  const [isMapsLoaded, setIsMapsLoaded] = useState(false);

  const increasePassenger = () => setPassenger(prev => prev + 1);
  const decreasePassenger = () => setPassenger(prev => (prev > 1 ? prev - 1 : 1));

  const handleSubmit = (e) => {
    e.preventDefault();

    const params = new URLSearchParams({
      pickup_address: pickup.address,
      pickup_lat: pickup.lat,
      pickup_lng: pickup.lng,
      dropoff_address: dropoff.address,
      dropoff_lat: dropoff.lat,
      dropoff_lng: dropoff.lng,
      date: date.toISOString().split("T")[0],
      passengers: passenger,
    }).toString();

    navigate(`/search?${params}`);
  };

  document.title = "Home | Sawari Online";

  return (
    <div>
      <section
        className="hero-section d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "70vh",
          backgroundImage:
            "url('https://cdn.blablacar.com/k/a/images/carpool_only_large-138d9f97c3f7113d.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-white fw-bold text-center mb-4 hero-title">
          Your pick of rides at low prices
        </h1>

        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
          libraries={["places"]}
          onLoad={() => setIsMapsLoaded(true)}
        >
        <div className="card p-4 search-card w-90" style={{ maxWidth: "1200px" }}>
          <form className="row g-3 align-items-center" onSubmit={handleSubmit}>
            {/* Pickup */}
            <div className="col-md-3 col-12 input-icon">
              <FaMapMarkerAlt className="field-icon" />
              {isMapsLoaded ? (
                <Autocomplete
                  options={{
                    componentRestrictions: { country: "pk" },
                  }}
                  onLoad={(auto) => (window.pickupAutoComplete = auto)}
                  onPlaceChanged={() => {
                    const place = window.pickupAutoComplete.getPlace();
                    setPickup({
                      address: place.formatted_address,
                      lat: place.geometry.location.lat(),
                      lng: place.geometry.location.lng(),
                    });
                  }}
                >
                  <input type="text" className="form-control ps-5" placeholder="Leaving From" required />
                </Autocomplete>
              ) : (
                <input
                  type="text"
                  className="form-control ps-5 bg-light"
                  placeholder="Loading..."
                  disabled
                />
              )}
            </div>

            {/* Dropoff */}
            <div className="col-md-3 col-12 input-icon">
              <FaMapMarkerAlt className="field-icon" />
              {isMapsLoaded ? (
                <Autocomplete
                  options={{
                    componentRestrictions: { country: "pk" },
                  }}
                  onLoad={(auto) => (window.dropoffAutoComplete = auto)}
                  onPlaceChanged={() => {
                    const place = window.dropoffAutoComplete.getPlace();
                    setDropoff({
                      address: place.formatted_address,
                      lat: place.geometry.location.lat(),
                      lng: place.geometry.location.lng(),
                    });
                  }}
                >
                  <input type="text" className="form-control ps-5" placeholder="Going To" required />
                </Autocomplete>
              ) : (
                <input
                  type="text"
                  className="form-control ps-5 bg-light"
                  placeholder="Loading..."
                  disabled
                />
              )}
            </div>

            {/* Date */}
            <div className="col-md-3 col-12 input-icon">
              <FaCalendarAlt className="field-icon" />
              <Flatpickr
                className="form-control d-block"
                value={date}
                options={{
                  altInput: true,
                  altFormat: "F j, Y",
                  dateFormat: "Y-m-d",
                  minDate: "today",
                }}
                onChange={(dates) => setDate(dates[0])}
              />
            </div>

            {/* Passengers */}
            <div className="col-md-2 col-12">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FaUsers />
                </span>
                <input
                  type="text"
                  className="form-control text-center"
                  value={passenger}
                  readOnly
                  style={{ cursor: "pointer" }}
                />
                <button type="button" className="btn btn-outline-secondary" onClick={increasePassenger}>+</button>
                <button type="button" className="btn btn-outline-secondary" onClick={decreasePassenger}>-</button>
              </div>
            </div>

            {/* Search Button */}
            <div className="col-md-1 col-12 d-grid">
              <button type="submit" className="btn btn-primary w-100">
                Search
              </button>
            </div>
          </form>
        </div>
        </LoadScript>
      </section>

      <section className="about-sec bg-white">
        <div className="aboutus_main">
          <div className="container">
            <div className="row text-center align-items-center">

              <div className="col-4 text-start">
                <div className="text-dark fw-bold text-start">
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    width="40"
                    height="40"
                  >
                    <g color="neutralTxtModerate">
                      <g color="currentColor">
                        <path
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.5 5v2.5h8V5zM7 4.5v3H6a1 1 0 0 0-1 1v3H4a1 1 0 0 0-1 1V16a1 1 0 0 0 1 1h1v3a1 1 0 0 0 1 1h9.5a5.5 5.5 0 0 0 .5-10.978V9h1a1 1 0 0 0 1-1V4.5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1m7.5 5.59V9h-8v2.5h5.225a5.5 5.5 0 0 1 2.775-1.41M10.6 13H4.5v2.5H10c0-.9.216-1.75.6-2.5m-.393 4H6.5v2.5h5.225a5.5 5.5 0 0 1-1.518-2.5m9.293-1.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <h6 className="text-dark fw-bold text-start">
                  Your pick of rides at low prices
                </h6>
                <h6 className="text-gray text-start mb-4">
                  No matter where you’re going, by bus or carpool, find the perfect ride from our wide range of destinations and routes at low prices.
                </h6>
              </div>

              <div className="col-4 text-start">
                <div className="text-dark fw-bold text-start">
                  <svg width="40"
                    height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="_1rks9rr1 ejccx3k5 ejccx3f ejccx3kp ejccx3f"><g color="neutralTxtModerate"><g color="currentColor"><path fill="currentColor" fill-rule="evenodd" d="M20 5.5H4a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M13.5 15.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75M13.5 12a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75M13.5 8.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75M8.875 10.25a.75.75 0 0 0-1.5 0v2.531c-.662.29-1.125.95-1.125 1.719v.5H5v-.5c0-1.077.544-2.026 1.373-2.588a2.25 2.25 0 1 1 3.504 0A3.12 3.12 0 0 1 11.25 14.5v.5H10v-.5c0-.769-.463-1.43-1.125-1.719z" clip-rule="evenodd"></path></g></g></svg>
                </div>
                <h6 className="text-dark fw-bold text-start">
                  Trust who you travel with
                </h6>
                <h6 className="text-gray text-start mb-4">
                  We take the time to get to know each of our members and bus partners. We check reviews, profiles and IDs, so you know who you’re travelling with and can book your ride at ease on our secure platform.
                </h6>
              </div>

              <div className="col-4 text-start">
                <div className="text-dark fw-bold text-start">
                  <svg width="40"
                    height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="_1rks9rr1 ejccx3k5 ejccx3f ejccx3kp ejccx3f"><g color="neutralTxtModerate"><g color="currentColor"><path fill="currentColor" fill-rule="evenodd" d="M12.5 11.5V5.958L7.52 12.5h3.98v5.542l4.98-6.542zm5.999-1.498a.5.5 0 0 1 .398.801l-8.45 11.098a.25.25 0 0 1-.449-.151v-7.752H5.501a.5.5 0 0 1-.398-.801l8.45-11.098a.25.25 0 0 1 .449.151v7.752z" clip-rule="evenodd"></path></g></g></svg>
                </div>
                <h6 className="text-dark fw-bold text-start">
                  Scroll, click, tap and go!
                </h6>
                <h6 className="text-gray text-start mb-4">
                  Booking a ride has never been easier! Thanks to our simple app powered by great technology, you can book a ride close to you in just minutes.
                </h6>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="about-sec bg-primary">
        <div className="aboutus_main">
          <div className="container">
            <div className="row justify-content-between align-items-center g-3 g-lg-5">

              <div className="col-12 col-lg-6">
                <div className="card h-100 border-0 bg-transparent">
                  <img src="https://cdn.blablacar.com/k/a/images/scamDetective-80f3a8463074443b.svg" alt="aboutus img" className="rounded-4 aboutus_leftimg aboutus-img" />
                </div>
              </div>

              <div className="col-12 col-lg-6 text-center">
                <h1 className="text-white fw-bold text-center mb-4">
                  Help us keep you safe from scams
                </h1>
                <h6 className="text-white fw-bold text-center mb-4">
                  At Sawari Online, we're working hard to make our platform as secure as it can be. But when scams do happen, we want you to know exactly how to avoid and report them. Follow our tips to help us keep you safe.
                </h6>
                <button className="btn btn-primary text-white">Learn more</button>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="about-sec">
        <div className="aboutus_main">
          <div className="container">
            <div className="row justify-content-between align-items-center g-3 g-lg-5">

              <div className="col-12 col-lg-6 text-center">
                <h1 className="text-dark fw-bold text-center mb-4">
                  Your pick of rides at low prices
                </h1>
                <h6 className="text-dark fw-bold text-center mb-4">
                  Let's make this your least expensive journey ever.
                </h6>
                <button className="btn btn-primary bg-primary">Offer a ride</button>
              </div>

              <div className="col-12 col-lg-6">
                <div className="card h-100 border-0 bg-transparent">
                  <img src="https://cdn.blablacar.com/k/a/images/driver-8b8061fb1af127e7.svg" alt="aboutus img" className="rounded-4 aboutus_leftimg aboutus-img" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default FrontPageHome;